import { supabase } from '@/config/supabase'

export interface OmiCorrezione {
  key: string
  value: number
  label: string
  categoria: 'globale' | 'provincia' | 'caratteristiche' | 'tipo_immobile' | 'servizi'
}

let cached: OmiCorrezione[] | null = null
let cacheTimestamp = 0
const CACHE_TTL = 5 * 60 * 1000
const NEGATIVE_CACHE_TTL = 30 * 1000

export async function fetchCorrezioni(): Promise<OmiCorrezione[]> {
  if (cached && Date.now() - cacheTimestamp < CACHE_TTL) return cached

  const { data, error } = await supabase
    .from('omi_correzioni')
    .select('key, value, label, categoria')
    .order('categoria')

  if (error || !data) {
    console.error('[omi-correzioni] fetch failed, using fallback:', error?.message)
    if (!cached) {
      cached = []
      cacheTimestamp = Date.now() - (CACHE_TTL - NEGATIVE_CACHE_TTL)
    }
    return cached
  }

  cached = data.map(r => ({
    key: r.key,
    value: Number(r.value) || 0,
    label: r.label,
    categoria: r.categoria,
  }))
  cacheTimestamp = Date.now()
  return cached
}

export async function saveCorrezioni(correzioni: OmiCorrezione[]): Promise<void> {
  const rows = correzioni.map(c => ({
    key: c.key,
    value: c.value,
    label: c.label,
    categoria: c.categoria,
    updated_at: new Date().toISOString(),
  }))

  const { error } = await supabase
    .from('omi_correzioni')
    .upsert(rows, { onConflict: 'key' })

  if (error) throw new Error(error.message)

  cached = null
  cacheTimestamp = 0
}

export function getCorrezione(correzioni: OmiCorrezione[], key: string): number {
  return correzioni.find(c => c.key === key)?.value ?? 0
}
